module.exports = __webpack_public_path__ + "img/if_6.07733c4c.png";